import OriginFilter from '@/language/pt/components/filter/OriginFilter';
import FieldFilter from '@/language/pt/components/filter/FieldFilter';
import OperationFilter from '@/language/pt/components/filter/OperationFilter';
import SortingFilter from '@/language/pt/components/filter/SortingFilter';
import ComponentTypeFilter from '@/language/pt/components/filter/ComponentTypeFilter';
import WidthFilter from '@/language/pt/components/filter/WidthFilter';
import HeightFilter from '@/language/pt/components/filter/HeightFilter';
import RepliedFilter from '@/language/pt/components/filter/RepliedFilter';
import ChannelFilter from '@/language/pt/components/filter/ChannelFilter';
import DarkPostFilter from '@/language/pt/components/filter/DarkPostFilter';
import PageFilter from '@/language/pt/components/filter/PageFilter';
import GenderFilter from '@/language/pt/components/filter/GenderFilter';
import PolarityFilter from '@/language/pt/components/filter/PolarityFilter';
import UserFilter from '@/language/pt/components/filter/UserFilter';
import ContractFilter from '@/language/pt/components/filter/ContractFilter';
import DomainsFilter from '@/language/pt/components/filter/DomainsFilter';
import DeskTagsFilter from '@/language/pt/components/filter/DeskTagsFilter';
import StatusFilter from '@/language/pt/components/filter/StatusFilter';
import BotFilter from '@/language/pt/components/filter/BotFilter';
import CheckedPosts from '@/language/pt/components/filter/CheckedPosts';
import ScheduledFilter from '@/language/pt/components/filter/ScheduledFilter';
import CampaignNameFilter from '@/language/pt/components/filter/CampaignNameFilter';
import CategoryFilter from '@/language/pt/components/filter/CategoryFilter';
import PostByIdFilter from '@/language/pt/components/filter/PostByIdFilter';
import OperatorsFilter from '@/language/pt/components/filter/OperatorsFilter';
import TeamsFilter from '@/language/pt/components/filter/TeamsFilter';
import SacTypeFilter from '@/language/pt/components/filter/SacTypeFilter';
import TagView from '@/language/pt/components/filter/TagView';
import MultiSelectFilter from '@/language/pt/components/filter/MultiSelectFilter';
import NegativationFilter from '@/language/pt/components/filter/NegativationFilter';
import RepliersFilter from '@/language/pt/components/filter/RepliersFilter';
import StudioMultiSelect from '@/language/pt/components/filter/StudioMultiSelect';

export default {
  OriginFilter,
  FieldFilter,
  OperationFilter,
  SortingFilter,
  ComponentTypeFilter,
  WidthFilter,
  HeightFilter,
  RepliedFilter,
  ChannelFilter,
  DarkPostFilter,
  PageFilter,
  GenderFilter,
  PolarityFilter,
  UserFilter,
  ContractFilter,
  DomainsFilter,
  DeskTagsFilter,
  StatusFilter,
  BotFilter,
  CheckedPosts,
  ScheduledFilter,
  CampaignNameFilter,
  CategoryFilter,
  PostByIdFilter,
  OperatorsFilter,
  TeamsFilter,
  SacTypeFilter,
  TagView,
  MultiSelectFilter,
  NegativationFilter,
  RepliersFilter,
  StudioMultiSelect,
};
